import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const MONTHLY_FINANCE = buildModuleApi({
    prefix: "MONTHLY_FINANCE",
    uri: "monthly-finance",
    withExtra: false,
    exclude: ["LIST", "CREATE", "UPDATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    extraActions: {
        ENTRY_LIST: { suffix: "/entries" },
        ENTRY_CREATE: { suffix: "/entries" },
        ENTRY_UPDATE: { suffix: "/entries" },
        ENTRY_REMOVE: { suffix: "/entries" },
        ENTRY_ARCHIVE_LIST: { suffix: "/entries/archived/list" },
        ENTRY_ARCHIVE: { suffix: "/entries/:id/archive" },
        ENTRY_RESTORE: { suffix: "/entries/:id/restore" },
        RECURRING_LIST: { suffix: "/recurring" },
        RECURRING_CREATE: { suffix: "/recurring" },
        RECURRING_UPDATE: { suffix: "/recurring" },
        RECURRING_REMOVE: { suffix: "/recurring" },
        RECURRING_ARCHIVE_LIST: { suffix: "/recurring/archived/list" },
        RECURRING_ARCHIVE: { suffix: "/recurring/:id/archive" },
        RECURRING_RESTORE: { suffix: "/recurring/:id/restore" },
        RECURRING_GENERATE: { suffix: "/recurring/generate-period" },
        BUDGET_LIST: { suffix: "/budgets" },
        BUDGET_CREATE: { suffix: "/budgets" },
        BUDGET_UPDATE: { suffix: "/budgets" },
        BUDGET_REMOVE: { suffix: "/budgets" },
        BUDGET_ARCHIVE_LIST: { suffix: "/budgets/archived/list" },
        BUDGET_ARCHIVE: { suffix: "/budgets/:id/archive" },
        BUDGET_RESTORE: { suffix: "/budgets/:id/restore" },
    },
});

export const MONTHLY_FINANCE_API = MONTHLY_FINANCE.API;
export const MONTHLY_FINANCE_CONSTANTS = MONTHLY_FINANCE.CONSTANTS;
export const MONTHLY_FINANCE_ENDPOINTS = MONTHLY_FINANCE.ENDPOINTS;
